import createReactAngularDirective from '../../lib/createReactAngularDirective';
import { FeeSummary } from '../../components/ReturnSummary/FeeSummary';

export default createReactAngularDirective({
  Component: FeeSummary,
  directiveName: 'feeSummary',
  withProvider: true,
  replace: true,
  template: `<div class="summary-fees-container" aria-label="Fee Summary"></div>`,
});
